// extracted by mini-css-extract-plugin
export var container = "bd_b";
export var device = "bd_fh";
export var deviceContainer = "bd_fg";
export var icon = "bd_bq";
export var icons = "bd_bw";
export var image = "bd_g";
export var logo = "bd_br";
export var model = "bd_fj";
export var section = "bd_d";